import { categories } from '@/mocks/movies';

const faqData = [
  {
    question: '番茄影视需要付费吗？',
    answer: '番茄影视是一个完全免费的影视资源平台，所有电影、电视剧、综艺、动漫内容均可免费在线观看，无需任何付费或订阅。我们始终坚持免费为用户提供高清流畅的观影体验。',
  },
  {
    question: '番茄影视支持哪些设备观看？',
    answer: '番茄影视支持全平台观看，包括电脑端（Windows/Mac）、手机端（iOS/Android）、平板电脑以及智能电视。只需打开浏览器访问番茄影视，即可随时随地畅享海量影视内容。',
  },
  {
    question: '如何搜索我想看的影视内容？',
    answer: '您可以通过页面顶部的搜索框直接输入影片名称进行搜索，也可以通过影视分类（电影、电视剧、综艺、动漫）浏览找到感兴趣的内容。我们还在首页设置了热门推荐和最新上架专区，帮助您快速发现好片。',
  },
  {
    question: '番茄影视的画质怎么样？',
    answer: '番茄影视提供高清及以上画质的影视资源，大部分内容支持1080P全高清播放。我们采用了先进的视频编码和CDN加速技术，确保播放流畅不卡顿，即使是在网络条件一般的情况下也能获得良好的观影体验。',
  },
  {
    question: '观看时需要安装插件或播放器吗？',
    answer: '不需要。番茄影视基于HTML5技术构建，您无需安装任何插件或第三方播放器，使用现代浏览器（Chrome、Safari、Edge、Firefox等）即可直接播放所有影视内容。',
  },
  {
    question: '番茄影视的资源更新速度快吗？',
    answer: '番茄影视拥有专业的资源运营团队，热门影视内容通常在播出后24小时内上线。电影频道持续更新院线新片，电视剧频道每日更新热播剧集，确保您能第一时间看到最新的精彩内容。',
  },
  {
    question: '如何在番茄影视上找到适合全家观看的内容？',
    answer: '番茄影视的动漫频道包含大量适合儿童观看的优质动画作品，综艺频道也有众多适合全家欢笑的节目。您还可以使用分类筛选功能按类型、年份等条件找到适合不同年龄段观众的内容。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const schemaFAQ = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
              <i className="ri-question-answer-line text-primary-500 mr-2"></i>
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">关于番茄影视，你可能想知道的一切</p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <i
                    className={`text-foreground-500 text-sm transition-transform flex-shrink-0 ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <script type="application/ld+json">
        {JSON.stringify(schemaFAQ)}
      </script>
    </>
  );
}